// extracted by mini-css-extract-plugin
module.exports = {"parentWrapper":"AMEOy","carouselContainer":"OTSYo","adContent":"GFzWQ","active":"SzZds","navBtn":"D2Meu","prev":"_MFqg","next":"cRboD"};